export default __webpack_public_path__ + "static/media/warning--double-side-roads-right--g1.d5e87954.png";